module.exports = __webpack_public_path__ + "static/media/icon-detail.4dc7ec35.svg";